/* eslint-disable react/prop-types */
import './Footer.css';
import { Link } from 'react-router-dom';
import SocialLinks from '../SocialLinks/SocialLinks';
import { easternCalendarYear } from '../../Utils/dateTime';

const Footer = ({ variant = 'default' }) => {
  const currentYear = easternCalendarYear();

  return (
    <footer className={`site-footer ${variant === 'storefront' ? 'storefront-footer' : ''}`}>
      <div className='footer-shell'>
        <div className='footer-brand'>
          <h2>Aunt Jack&apos;s Peanut Shack</h2>
          <p>Handing you a warm bag of peanuts at every festival, tailgate, and family reunion.</p>
        </div>
        <div className='footer-links'>
          <h3>Stay Connected</h3>
          <Link to={'/events'}>Upcoming events</Link>
          <Link to={'/catering'}>Catering packages</Link>
          <Link to={'/shop'}>Shop flavors</Link>
          <Link to={'mailto:carjack@myyahoo.com'}>carjack@myyahoo.com</Link>
          <SocialLinks variant='footer' />
        </div>
        <div className='footer-meta'>
          <p>&copy; {currentYear} Aunt Jack&apos;s Peanut Shack. All rights reserved.</p>
          <p className='footer-note'>Crafted with love in Georgia.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
